var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseRecording(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5H12.5C12.0397 2.5 11.6666 2.8731 11.6666 3.33333V16.6667C11.6666 17.1269 12.0397 17.5 12.5 17.5H15C15.4602 17.5 15.8333 17.1269 15.8333 16.6667V3.33333C15.8333 2.8731 15.4602 2.5 15 2.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 2.5H4.99996C4.53972 2.5 4.16663 2.8731 4.16663 3.33333V16.6667C4.16663 17.1269 4.53972 17.5 4.99996 17.5H7.49996C7.9602 17.5 8.33329 17.1269 8.33329 16.6667V3.33333C8.33329 2.8731 7.9602 2.5 7.49996 2.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseRecording);
export default __webpack_public_path__ + "static/media/pause_recording.dd22f57f75b683b0cc878b204720aaf3.svg";
export { ForwardRef as ReactComponent };